import { render, staticRenderFns } from "./ItemRepeater.vue?vue&type=template&id=02b2d9d8&scoped=true&"
import script from "./ItemRepeater.vue?vue&type=script&lang=js&"
export * from "./ItemRepeater.vue?vue&type=script&lang=js&"
import style0 from "./ItemRepeater.vue?vue&type=style&index=0&id=02b2d9d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b2d9d8",
  null
  
)

export default component.exports